import React, { useState } from "react";

const ClinicalTemplates = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div className="tab-panel">
        <div className="section-title_user">
          <span>Clinical Templates</span>
          <button
            className="add-button_user"
            onClick={() => setIsModalOpen(true)}
          >
            Add Template
          </button>
        </div>
        <table className="table">
          <thead>
            <tr>
              <th>Template Name</th>
              <th>Type</th>
              <th>Last Updated</th>
              <th>Used In</th>
              <th style={{ textAlign: "right" }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Initial Psychiatric Evaluation</td>
              <td>Assessment</td>
              <td>2025-05-10</td>
              <td>Intake, Follow-ups</td>
              <td style={{ textAlign: "right" }}>
                <button className="action_icon_btn" title="Preview">
                  <i className="fas fa-eye" />
                </button>
                <button className="action_icon_btn" title="Duplicate">
                  <i className="fas fa-copy" />
                </button>
                <button className="action_icon_btn" title="Edit">
                  <i className="fas fa-edit" />
                </button>
                <button className="action_icon_btn" title="Export">
                  <i className="fas fa-file-export" />
                </button>
                <button className="action_icon_btn" title="Delete">
                  <i className="fas fa-trash-alt" />
                </button>
              </td>
            </tr>
            <tr data-template-id={2}>
              <td>SOAP Note</td>
              <td>Progress Note</td>
              <td>2025-05-08</td>
              <td>All Sessions</td>
              <td style={{ textAlign: "right" }}>
                <button className="action_icon_btn" title="Preview" >
                  <i className="fas fa-eye" />
                </button>
                <button className="action_icon_btn" title="Duplicate">
                  <i className="fas fa-copy" />
                </button>
                <button className="action_icon_btn" title="Edit">
                  <i className="fas fa-edit" />
                </button>
                <button className="action_icon_btn" title="Export">
                  <i className="fas fa-file-export" />
                </button>
                <button className="action_icon_btn" title="Delete">
                  <i className="fas fa-trash-alt" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className={`modal_setting ${isModalOpen ? "active" : ""}`}>
        <div className="modal-content_setting">
          <span
            className="close_setting"
            onClick={() => setIsModalOpen(false)}
            style={{ cursor: "pointer" }}
          >
            ×
          </span>
          <h2>Clinical Template Editor</h2>
          <form>
            <div className="form-row_setting">
              <div>
                <label>Template Name</label>
                <input
                  type="text"
                  placeholder="e.g., Initial Assessment"
                  required
                />
              </div>
              <div>
                <label>Template Type</label>
                <select id="templateType" required="">
                  <option value="">Select...</option>
                  <option>Assessment</option>
                  <option>Progress Note</option>
                  <option>Treatment Plan</option>
                  <option>Discharge Summary</option>
                </select>
              </div>
            </div>
            <label>Template Content</label>
            <textarea
              id="templateContent"
              className="template-editor"
              placeholder="Enter template content with placeholders like {{patient.name}}"
              defaultValue={""}
            />
            <div className="form-row_setting">
              <div>
                <label>Default Assign To</label>
                <select id="templateAssignTo">
                  <option value="all">All Providers</option>
                  <option value="psychiatrist">Psychiatrists Only</option>
                  <option value="therapist">Therapists Only</option>
                </select>
              </div>
              <div>
                <label>Status</label>
                <select id="templateStatus" required="">
                  <option value="active">Active</option>
                  <option value="draft">Draft</option>
                  <option value="archived">Archived</option>
                </select>
              </div>
            </div>
            <button
              type="submit"
              className="add-button_user"
              style={{ alignSelf: "left", marginTop: 10, display: "flex" }}
            >
              Save Template
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default ClinicalTemplates;
